





























import Vue from 'vue';
import Component from 'vue-class-component';

import { mapState } from 'vuex';

/** The Header of the application */
@Component({
	computed: mapState('home', ['routename'])
})
export default class Header extends Vue {}
